import * as React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { remRhythm } from 'localmed-core';

import TrackClick from '../TrackClick';
import {
  buildIcalUrl,
  buildGoogleCalendarUrl,
  buildOutlookCalendarUrl,
  buildYahooCalendarUrl,
} from '../../utils/calendarUrls';
import Popover from '../DiComponents/Popover';

const List = styled('ul')(
  ({ theme }) => css`
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: ${remRhythm(6)};
    border-radius: ${theme.radii.md};
    overflow: hidden;
  `
);

export default function AddToCalendarLink({
  id,
  calendarEvent,
  trackingEventComponentName,
  children,
  ListLink,
  Link,
  Icon,
  popoverProps,
  ...props
}) {
  const fileName = `${calendarEvent.title}.ics`;

  return (
    <TrackClick
      event="Clicked Add to Calendar"
      eventProperties={trackingEventComponentName ? { component: trackingEventComponentName } : {}}
    >
      {(getTrackingProps) => (
        <Popover
          id={id || 'add-to-calendar-link'}
          {...popoverProps}
          content={
            <List>
              <li>
                <ListLink
                  as="a"
                  href={buildIcalUrl(calendarEvent)}
                  download={fileName}
                  {...getTrackingProps({ eventProperties: { calendarType: 'Apple' } })}
                >
                  Apple Calendar
                </ListLink>
              </li>
              <li>
                <ListLink
                  as="a"
                  href={buildGoogleCalendarUrl(calendarEvent)}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...getTrackingProps({ eventProperties: { calendarType: 'Google' } })}
                >
                  Google
                </ListLink>
              </li>
              <li>
                <ListLink
                  as="a"
                  href={buildIcalUrl(calendarEvent)}
                  download={fileName}
                  {...getTrackingProps({ eventProperties: { calendarType: 'Outlook' } })}
                >
                  Outlook
                </ListLink>
              </li>
              <li>
                <ListLink
                  as="a"
                  href={buildOutlookCalendarUrl(calendarEvent)}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...getTrackingProps({ eventProperties: { calendarType: 'Outlook.com' } })}
                >
                  Outlook.com
                </ListLink>
              </li>
              <li>
                <ListLink
                  as="a"
                  href={buildYahooCalendarUrl(calendarEvent)}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...getTrackingProps({ eventProperties: { calendarType: 'Yahoo' } })}
                >
                  Yahoo
                </ListLink>
              </li>
            </List>
          }
        >
          {children || (
            <Link {...props}>
              {Icon && <Icon />}
              Add to Calendar
            </Link>
          )}
        </Popover>
      )}
    </TrackClick>
  );
}
